export default "__VITE_ASSET__ca3aac1c__"